export default __webpack_public_path__ + "a1e48adbc0012077cb6267e61a99d375.png";